<template>
	<section class="Widget" id="widget">
		<Header />
		<div class="chat-log">
			<Chats />
		</div>
		<Progress v-if="style === 'survey'" />
		<!-- <Input /> -->
	</section>
</template>

<script>
	import Header from './Header';
	import Chats from './Chats';
	import Input from './Input';
	import Progress from './styles/survey/Progress';
	import { mapState } from 'vuex';

	export default {
		components: {
			Header,
			Chats,
			Input,
			Progress
		},

		computed: {
			...mapState(['style'])
		}
	};
</script>

<style scoped lang="scss">
	.Widget {
		display: flex;
		flex-direction: column;
		height: 100%;

		.chat-log {
			position: relative;
			flex: 1 0 auto;
			background-color: #f9fafe;

			.Chats {
				position: absolute;
				width: 100%;
				height: 100%;
				overflow-x: hidden;
				overflow-y: auto;
			}
		}
	}
</style>
